<template>
  <base-table
    :service="$options.contractService"
    fetch-func="all"
    :fetchParams="{
      exclude_archived: 1,
      includes: 'contractor',
      order_by: undefined,
      sort_by: undefined,
    }"
    :columns="columns"
    default-sort-field="contractor.name"
    default-sort-direction="asc"
    checkable
    :checked.sync="contractsChecked"
    :custom-is-checked="(a, b) => a.id == b.id"
    :is-row-checkable="() => canManageContracts"
    @check="onTableCheck"
    @check-all="onTableCheckAll"
    ui-pagination
    ref="baseTable"
  >
    <template #rowContractor="{ row }">
      {{ row.contractor ? row.contractor.name : "" }}
    </template>
  </base-table>
</template>

<script>
import BaseTable from "@/components/partials/BaseTable";
import { ContractService } from "@/services/contract.service";
import { UserService } from "@/services/user.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";

export default {
  contractService: ContractService,
  props: {
    user: {
      required: true,
    },
  },
  components: {
    BaseTable,
  },
  data: () => ({
    columns: [
      {
        field: "contractor.name",
        label: "Contractor",
        sortable: true,
      },
      { field: "name", label: "Name", sortable: true },
    ],
    contractsChecked: [],
  }),
  computed: {
    canManageContracts() {
      return this.$store.getters["Auth/hasPermission"]("can manage contracts");
    },
  },
  async mounted() {
    await this.fetchContracts();
    this.fetchUserContracts();
  },
  watch: {
    user() {
      this.fetchUserContracts();
    },
  },
  methods: {
    async fetchContracts() {
      await this.$refs.baseTable.fetchData();
    },
    async fetchUserContracts() {
      try {
        this.$refs.baseTable.loading = true;
        this.contractsChecked = await UserService.listContracts(
          this.user.id
        ).then((response) => JsonDenormalizer.denormalize(response));
      } catch (err) {
        console.error(err);
      } finally {
        this.$refs.baseTable.loading = false;
      }
    },
    async archiveContracts(contracts) {
      try {
        this.$refs.baseTable.loading = true;
        await UserService.archiveContracts(this.user.id, {
          contract_ids: contracts.map((v) => v.id),
        });
        this.$buefy.toast.open({
          message: "Contract/s has been detached.",
          type: "is-info",
          position: "is-top-right",
        });
      } catch (err) {
        await this.fetchUserContracts();
        console.error(err);
      } finally {
        this.$refs.baseTable.loading = false;
      }
    },
    async restoreContracts(contracts) {
      try {
        this.$refs.baseTable.loading = true;
        await UserService.restoreContracts(this.user.id, {
          contract_ids: contracts.map((v) => v.id),
        });
        this.$buefy.toast.open({
          message: "Contract/s has been attached.",
          type: "is-info",
          position: "is-top-right",
        });
      } catch (err) {
        await this.fetchUserContracts();
        console.error(err);
      } finally {
        this.$refs.baseTable.loading = false;
      }
    },
    onTableCheck(checked, row) {
      if (row) {
        if (!!checked.find((v) => v.id == row.id)) {
          this.restoreContracts([row]);
        } else {
          this.archiveContracts([row]);
        }
      }
    },
    onTableCheckAll(checked) {
      if (
        checked.filter(
          (v) => !!this.$refs.baseTable.data.find((vv) => vv.id == v.id)
        ).length
      ) {
        this.restoreContracts(this.$refs.baseTable.data);
      } else {
        this.archiveContracts(this.$refs.baseTable.data);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/Organization/persons/userContracts.vue